var map = {
	"./3rdParty.svg": 283,
	"./Accident.svg": 284,
	"./Bicycle.svg": 285,
	"./Boat.svg": 286,
	"./Buildings.svg": 287,
	"./Car.svg": 288,
	"./Child.svg": 289,
	"./Contents.svg": 290,
	"./CriticalIllness.svg": 291,
	"./Dental.svg": 292,
	"./Drone.svg": 293,
	"./ExtendedWarranty.svg": 294,
	"./Family.svg": 295,
	"./Gadget.svg": 296,
	"./Health.svg": 297,
	"./Hospitalização.svg": 298,
	"./Housekeeper.svg": 299,
	"./Hunter.svg": 300,
	"./Income.svg": 301,
	"./Investment.png": 770,
	"./Investment.svg": 302,
	"./Life.svg": 303,
	"./LocalLodging.svg": 304,
	"./Mobile.svg": 305,
	"./Mortgage.svg": 306,
	"./Motorbike.svg": 307,
	"./Other.svg": 308,
	"./PPR.svg": 309,
	"./Pet.svg": 310,
	"./Ppr.png": 771,
	"./Scooter.svg": 311,
	"./Sports.png": 772,
	"./Sports.svg": 312,
	"./Thirdpartypet.png": 773,
	"./Thirdpartypet.svg": 313,
	"./Travel.svg": 314,
	"./Warranty.svg": 315,
	"./White_goods.svg": 316,
	"./WorkAccident.svg": 317,
	"./locallodging.png": 774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;